/**
 * Visual Filters Integration
 * Triggers facet form submission when visual filter checkboxes are clicked
 */

document.addEventListener('DOMContentLoaded', function() {
  ensureNoPaginationForMemberFilters();
  switchToActiveTab();
  initVisualFilters();
  syncCheckboxesWithURL(); // Sync on page load
  hidePaginationIfMemberFilterActive(); // Hide pagination on initial load

  document.addEventListener('facets:updated', function() {
    syncCheckboxesWithURL();
    hidePaginationIfMemberFilterActive(); // Hide pagination after AJAX updates
  });
});

/**
 * Ensure pagination is disabled when member filters are active
 * Redirects to add limit parameter if member filter is active but limit is not set
 */
function ensureNoPaginationForMemberFilters() {
  const params = new URLSearchParams(window.location.search);

  // Check if member filter is active (using 'm' parameter)
  const hasMemberFilter = params.has('m');

  // If member filter is active, ensure pagination is disabled
  if (hasMemberFilter) {
    let needsRedirect = false;

    // Ensure limit is set to load all products
    if (!params.has('limit') || params.get('limit') !== '250') {
      params.set('limit', '250');
      needsRedirect = true;
    }

    // Always remove page parameter when member filter is active
    if (params.has('page')) {
      params.delete('page');
      needsRedirect = true;
    }

    // Redirect if changes were made
    if (needsRedirect) {
      window.location.href = window.location.pathname + '?' + params.toString();
    }
  }
}

/**
 * Switch to the appropriate tab based on active filters in URL
 */
function switchToActiveTab() {
  const params = new URLSearchParams(window.location.search);

  // Check if member filter is active in URL (using 'm' parameter)
  const hasMemberFilter = params.has('m');

  // If member filter is active, switch to Member tab
  if (hasMemberFilter) {
    const memberTabInput = document.getElementById('tab-member');
    if (memberTabInput) {
      memberTabInput.checked = true;
    }
  }
}

function initVisualFilters() {
  const visualFilterCheckboxes = document.querySelectorAll('.visual-filter-card__checkbox');
  const facetForm = document.querySelector('#FacetFiltersForm');

  if (!facetForm) {
    console.warn('FacetFiltersForm not found - visual filters cannot integrate with facets');
    return;
  }

  // Listen to ALL input changes in the facet form (catches sidebar filter changes)
  facetForm.addEventListener('input', function(e) {
    const input = e.target;

    // Check if this is a member filter that's NOT a visual filter card checkbox
    const isMemberInput = input.name && input.name.toLowerCase().includes('member');
    const isVisualFilterCard = input.classList.contains('visual-filter-card__checkbox');

    if (isMemberInput && !isVisualFilterCard) {
      // This is a sidebar member filter change - force full page refresh
      e.preventDefault();
      e.stopImmediatePropagation();

      setTimeout(function() {
        const formData = new FormData(facetForm);
        const params = new URLSearchParams();
        let hasMemberFilter = false;

        for (const [key, value] of formData.entries()) {
          if (value) {
            params.append(key, value);
            if (key.toLowerCase().includes('member')) {
              hasMemberFilter = true;
            }
          }
        }

        if (hasMemberFilter) {
          params.set('limit', '250');
        }

        window.location.href = window.location.pathname + '?' + params.toString();
      }, 0);
    }
  }, true); // Use capture phase to intercept before other handlers

  // Visual filter card checkboxes
  visualFilterCheckboxes.forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      // If this is a member checkbox, uncheck all other member checkboxes (single selection only)
      if (this.name && this.name.toLowerCase().includes('filter.v.option.member')) {
        if (this.checked) {
          // Uncheck all other member checkboxes
          visualFilterCheckboxes.forEach(function(otherCheckbox) {
            if (otherCheckbox !== checkbox &&
                otherCheckbox.name &&
                otherCheckbox.name.toLowerCase().includes('filter.v.option.member')) {
              otherCheckbox.checked = false;
            }
          });
        }
      }

      // For all visual filters, do a full page refresh to ensure proper filter combination
      const formData = new FormData(facetForm);
      const params = new URLSearchParams();
      let selectedMember = null;

      for (const [key, value] of formData.entries()) {
        if (value) {  // Only include non-empty values
          // Check if this is a member filter - DON'T send to Shopify
          if (key.toLowerCase().includes('filter.v.option.member')) {
            selectedMember = value; // Only one member can be selected now
          } else {
            // Send all other filters to Shopify (album, product type, etc.)
            params.append(key, value);
          }
        }
      }

      // If member filter selected, use client-side filtering
      if (selectedMember) {
        // Load all products
        params.set('limit', '250');
        // Store selected member in a parameter Shopify ignores
        params.append('m', selectedMember);
      }

      // Navigate to the new URL (full page refresh)
      window.location.href = window.location.pathname + '?' + params.toString();
    });
  });

  syncCheckboxesWithURL();
}

/**
 * Sync visual filter checkboxes with URL parameters
 * Ensures checkboxes match what's actually filtered
 */
function syncCheckboxesWithURL() {
  const visualFilterCheckboxes = document.querySelectorAll('.visual-filter-card__checkbox');
  const params = new URLSearchParams(window.location.search);

  visualFilterCheckboxes.forEach(function(checkbox) {
    const paramName = checkbox.name;
    const paramValue = checkbox.value;

    let isInURL = false;

    // For member filters, check the 'm' parameter (client-side only)
    if (paramName.toLowerCase().includes('filter.v.option.member')) {
      isInURL = params.getAll('m').includes(paramValue);
    } else {
      // For other filters, check standard parameters
      isInURL = params.getAll(paramName).includes(paramValue);
    }

    // Sync checkbox state with URL
    if (checkbox.checked !== isInURL) {
      checkbox.checked = isInURL;
    }
  });
}

/**
 * Hide pagination when member filters are active
 * This runs after AJAX updates to handle facets.js pagination rendering
 */
function hidePaginationIfMemberFilterActive() {
  const params = new URLSearchParams(window.location.search);

  // Check if member filter is active (using 'm' parameter)
  const hasMemberFilter = params.has('m');

  // Hide pagination if member filter is active
  if (hasMemberFilter) {
    const paginationWrapper = document.querySelector('.pagination-wrapper');
    const pagination = document.querySelector('.pagination');

    if (paginationWrapper) {
      paginationWrapper.style.display = 'none';
    }
    if (pagination) {
      pagination.style.display = 'none';
    }
  } else {
    // Show pagination if no member filter (restore normal behavior)
    const paginationWrapper = document.querySelector('.pagination-wrapper');
    const pagination = document.querySelector('.pagination');

    if (paginationWrapper) {
      paginationWrapper.style.display = '';
    }
    if (pagination) {
      pagination.style.display = '';
    }
  }
}
